import React from 'react';
import { motion } from 'framer-motion';
import { Info } from 'lucide-react';

const AboutSection = () => {
  return (
    <section className="py-24 md:py-32 px-6 bg-stone-50" data-testid="about-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-6" data-testid="about-title">
            What Is This?
          </h2>
          
          <div className="max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 bg-yellow-600 text-white px-6 py-3 rounded-full mb-8 font-medium" data-testid="disclaimer-badge">
              <Info className="w-5 h-5" />
              <span>This is a staged cultural experience, not a real wedding</span>
            </div>
            
            <p className="text-lg md:text-xl leading-relaxed text-stone-700 mb-6" data-testid="about-description">
              A ticketed, staged Kerala wedding experience where you get to attend a beautifully orchestrated 
              celebration — complete with traditional rituals, authentic <span className="font-accent italic text-emerald-900">Sadya</span> feast, 
              <span className="font-accent italic text-emerald-900"> Chenda Melam</span> performances, and stunning photo opportunities.
            </p>
            
            <p className="text-lg md:text-xl leading-relaxed text-stone-700" data-testid="about-extra">
              <strong>No real couple. No obligations. No gift anxiety.</strong> Just the full wedding vibe, 
              the food, the music, and memories you'll cherish forever.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;